import React, { useContext, useState } from "react";
import Navbar from "./Navbar";
import Brain from "../components/assets/brain (1).svg";

import { Link, Outlet } from "react-router-dom";
import ImageComponent from "../pages/articales/ImageComponent";
import { AuthContext } from "../AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import "./dash.css";

const LayoutDashboard = () => {
  const authContext = useContext(AuthContext);
  const [shown, setShown] = useState(true);
  const [activeItem, setActiveItem] = useState('articleDashboard');
  const handleSidebar = () => {
    setShown(!shown);
  };

  const handleItemClick = (item) => {
    setActiveItem(item);
  };

  return (
    <div>
      <Navbar handleSidebar={handleSidebar} shown={shown} setShown={setShown} />

      <div className="container-fluid">
        <div className="row flex-nowrap">
          <div className="col-3 col-md-3 col-xl-2   px-0 "
          style={{width:"0"}}
          >
            <div
              className={`${
                shown
                  ? " position-sticky d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-dark h-100"
                  : "  side d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-dark min-vh-100"
              }`}
              style={{
                backgroundColor: "#cdf",
                width: "220px",
                zIndex: "12266666666222",
              }}
            >
              <div className="d-flex  color-white justify-content-center flex-row align-items-center ">
                <div
                  className=" px-2 pb-2 "
                  style={{
                    width: "200px",
                    backgroundColor: "#cdf",
                    borderBottom: "2px solid #ccc",
                  }}
                >
                  <Link className=" px-2  " to="/">
                    <img src={Brain} style={{ width: "60px" }} alt="logo" />
                  </Link>
                  <span className="">SychoClinic</span>
                </div>
              </div>
              <ul
                className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start"
                id="menu"
              >
                <li className="nav-item my-3">
                  <div
                    className="nav-option option1"
                    style={{ borderBottom: "2px solid #acc" }}
                  >
                    <Link
                      to="/account"
                      className="rounded-circle  mt-1 d-flex align-items-center justify-content-center"
                      style={{
                        width: "60px",
                        height: "70px",
                        paddingBottom: "15px",
                      }}
                    >
                      <ImageComponent
                        base64String={authContext?.auth?.picture}
                        height={"100%"}
                        border={"100%"}
                      />
                    </Link>
                    <h6 style={{fontSize:"14px"}}>{authContext.auth.user}</h6>
                  </div>
                </li>
                <li className="nav-item my-2 ">
                  <Link
                    className="align-middle px-0 "
                    to="/articleDashboard"
                    onClick={() => handleItemClick("articleDashboard")}
                  >
                    <div
                      className={`px-3 py-2 d-flex flex-row align-items-center  text-black ${
                        activeItem === "articleDashboard" || ""
                          ? "bg-primary text-white "
                          : ""
                      }`}
                    >
                      <FontAwesomeIcon className={`fs-5 ${  activeItem ===
                          "articleDashboard"? ' bg-white text-white rounded-circle ': ''}  `} icon={faCircle} />
                      <span className="ms-1 d-sm-inline">Articles</span>
                    </div>
                  </Link>
                  <Link
                    className="align-middle px-0"
                    to="feedbackDashboard"
                    onClick={() => handleItemClick("feedbackDashboard")}
                  >
                    <div
                      className={`px-3 py-2 d-flex flex-row align-items-center my-4 text-black ${
                        activeItem === "feedbackDashboard" 
                          ? "bg-primary text-white"
                          : ""
                      }`}
                    >
                      <FontAwesomeIcon className={`fs-5 ${  activeItem ===
                          "feedbackDashboard"? ' bg-white text-white rounded-circle ': ''}  `} icon={faCircle} />
                      <span className="ms-1 d-sm-inline">Feedback</span>
                    </div>
                  </Link>
                  <Link
                    className="align-middle px-0"
                    to="conectUsDashboard"
                    onClick={() => handleItemClick("conectUsDashboard")}
                  >
                    <div
                      className={`px-3
                                    
                                          
                                              py-2 d-flex flex-row align-items-center my-4 text-black ${
                                                activeItem ===
                                                "conectUsDashboard"
                                                  ? "bg-primary text-white"
                                                  : ""
                                              }`}
                    >
                      <FontAwesomeIcon
                        className={`fs-5 ${
                          activeItem === "conectUsDashboard"
                            ? " bg-white text-white rounded-circle "
                            : ""
                        }  `}
                        icon={faCircle}
                      />
                      <span className="ms-1 d-sm-inline">Connect Us</span>
                    </div>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col ps-5 ms-0 py-3 ">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LayoutDashboard;
